/*

jv.Common.Directives.fallbackImage Module
===========================================

Copied from http://stackoverflow.com/questions/16349578/angular-directive-for-a-fallback-image

When ng-src does not resolve, need a way to resolve to show a placeholder image instead. 

 */
angular.module('jv.Common.Directives.fallbackImage', [])

.directive('fallbackSrc', function () {
  var fallbackSrc = {
    link: function postLink(scope, iElement, iAttrs) {
      iElement.on('error', function() {
        angular.element(this).attr("src", iAttrs.fallbackSrc);
      });
        iAttrs.$observe('ngSrc', function(value) {
          if (!value && iAttrs.fallbackSrc) {
            iAttrs.$set('src', iAttrs.fallbackSrc);
          }
        });
    }
   };
   return fallbackSrc;
 });